import { render, staticRenderFns } from "./subir.vue?vue&type=template&id=10582694&scoped=true"
import script from "./subir.vue?vue&type=script&lang=js"
export * from "./subir.vue?vue&type=script&lang=js"
import style0 from "./subir.vue?vue&type=style&index=0&id=10582694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10582694",
  null
  
)

export default component.exports